import styled from 'styled-components';
import { RoutesString } from 'common-modules/general/Config/routesString';

const FooterForm = styled.div`
  display: table-cell;
  vertical-align: top;
`;

const Txt1 = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-dMd';
  color: #4a5765;
  font-size: 18px;
  font-size: 1.125rem;
  ::after {
    content: '';
    width: 1px;
    height: 16px;
    display: inline-block;
    vertical-align: -2px;
    background-color: #e0e0e0;
    margin: 0 10px 0 12px;
    margin: 0 0.625rem 0 0.75rem;
  }
  :hover {
    color: #ff671d;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
  }
`;
const Txt2 = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-dMd';
  color: #4a5765;
  font-size: 18px;
  font-size: 1.125rem;
  ::after {
    content: '';
    width: 1px;
    height: 16px;
    display: inline-block;
    vertical-align: -2px;
    background-color: #e0e0e0;
    margin: 0 10px 0 12px;
    margin: 0 0.625rem 0 0.75rem;
  }
  :hover {
    color: #ff671d;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
  }
`;
const Txt3 = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-dMd';
  color: #4a5765;
  font-size: 18px;
  font-size: 1.125rem;
  :hover {
    color: #ff671d;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
  }
`;

const FooterMenuList = styled.div`
  margin-bottom: 1.875rem;
`;
const HoverTxts = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-bLt';
  color: #333;
  font-size: 16px;
  font-size: 1rem;
  margin-right: 23px;
  margin-right: 1.4375rem;
  &.font-family-sb {
    font-weight: bold;
  }
  :hover {
    color: #ff671d;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
  }
`;

const Txts = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-bLt';
  color: #666;
  font-size: 16px;
  font-size: 1rem;
  margin-right: 23px;
  margin-right: 1.4375rem;
`;
const List = styled.a`
  color: #333;
  font-size: 100%;
  text-decoration: none;
  font-family: inherit;

  &a:before {
    content: '　';
    position: absolute;
    font-size: 0;
  }
`;
const FooterLinkList = styled.div``;

const FooterCompanyInfo = styled.div`
  margin-top: 0.5rem;
`;
const FooterCopyright = styled.div`
  margin-top: 1.8rem;
  font-family: SDGothicNeobTTF-bLt;
  color: rgb(102, 102, 102);
  font-size: 1rem;
`;
const TxtRap = styled.div`
  display: inline-block;
`;

const InfoWrapper = () => {
  return (
    <FooterForm>
      <FooterMenuList>
        <List href={RoutesString.FooterNotice}>
          <Txt1>공지사항</Txt1>
        </List>
        <List href={RoutesString.FooterEvent01}>
          <Txt2>이벤트</Txt2>
        </List>
        <List href={RoutesString.FooterQuestion}>
          <Txt3>고객문의</Txt3>
        </List>
      </FooterMenuList>
      <FooterLinkList>
        <List href={RoutesString.Email}>
          <HoverTxts>이메일 무단 수집거부</HoverTxts>
        </List>
        <List href={RoutesString.Agree}>
          <HoverTxts>이용약관</HoverTxts>
        </List>
        {/* <!-- s: 2020508 개인정보처리방침 볼드 처리--> */}
        <List href={RoutesString.Person}>
          <HoverTxts className=" font-family-sb">개인정보처리방침</HoverTxts>
        </List>
        <List href={RoutesString.Policy}>
          <HoverTxts>영상정보처리기기운영 및 관리방침</HoverTxts>
        </List>
        <List href={RoutesString.Sitemap}>
          <HoverTxts>사이트맵</HoverTxts>
        </List>
        <List href={RoutesString.Laboratory}>
          {/* <!-- s 수정 20200320 텍스트 변경--> */}
          <HoverTxts>건축환경연구센터</HoverTxts>
          {/* <!-- e 수정 20200320 텍스트 변경--> */}
        </List>
      </FooterLinkList>
      <FooterCompanyInfo>
        <TxtRap>
          <Txts>사업자명:디엘건설(주)</Txts>
          <Txts>사업자등록번호:102-81-34561</Txts>
        </TxtRap>
        <TxtRap>
          <Txts>대표자:강윤호</Txts>
          <Txts>문의:080-535-3000</Txts>
        </TxtRap>
      </FooterCompanyInfo>
      <FooterCopyright>COPYRIGHT DL Construction. ALL RIGHTS RESERVED.</FooterCopyright>
    </FooterForm>
  );
};

export default InfoWrapper;
